module.exports = __webpack_public_path__ + "media/img/contact-us/offices/flag-germany-d49d3e173b320f54f51eadf4919b1366.png";